import { IVector } from "../interfaces";

export class Point implements IVector {
	public z: number = 0;

	public constructor(public x: number, public y: number) {}

	public static ToVector(point: Point): THREE.Vector3 {
		return new THREE.Vector3(point.x, point.y, point.z);
	}

	public static FromVector(vector: THREE.Vector3): Point {
		return new Point(vector.x, vector.y);
	}
}
